<template>
    <div id="date-range-attendance-container">
        <b-row>
            <b-col class="col-12 mt-2">
                <h4 class="page-title text-truncate">{{ $t('DateRangeAttendance.Title') }}</h4>
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.datefrom')"
                    :Model="parameters.dateFrom"
                    @input="dateFromChanged($event)"
                    :Id="'AttendanceDateFrom'"
                    :Type="'date'"
                    :isRequired="true"
                    :OnPressEnter="searchAsync"
                    :isConfirm="false"
                    :ReadOnly="searching"
                    :isValid="isDateFromValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.dateTo')"
                    :Model="parameters.dateTo"
                    @input="dateToChanged($event)"
                    :Id="'AttendanceDateTo'"
                    :Type="'date'"
                    :isRequired="true"
                    :OnPressEnter="searchAsync"
                    :isConfirm="false"
                    :ReadOnly="searching"
                    :isValid="isDateToValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$tc('Shared.Program', 2)"
                    v-bind:Options="programList"
                    v-bind:Model="programVModel"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:Placeholder="selectPlaceholder"
                    v-bind:Multiple="true"
                    v-bind:RequireEvent="true"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownPrograms"
                    :IsDisabled="searching"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$tc('Shared.Patient')"
                    v-bind:Options="patientList"
                    v-bind:Model="patientVModel"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:Multiple="true"
                    :Input="changeDropDownPatients"
                    :IsDisabled="searching"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$tc('Shared.Therapist', 2)"
                    v-bind:Options="therapistList"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:Model="therapistModel"
                    v-bind:Multiple="true"
                    :Input="changeDropDownTherapist"
                    :IsDisabled="searching"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Therapies')"
                    v-bind:Options="therapiesList"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:Model="therapiesModel"
                    v-bind:Multiple="true"
                    :Input="changeDropDownTherapy"
                    :IsDisabled="searching"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Billing')"
                    v-bind:Options="billingList"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:Model="billingModel"
                    v-bind:Multiple="true"
                    :Input="changeDropDownBilling"
                    :IsDisabled="searching"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="6" md="6" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('DateRangeAttendance.BypassFollowScheduler')"
                    v-bind:Name="'BypassFollowScheduler'"
                    v-bind:ClassProp="'AlignCheck mx-3'"
                    v-bind:CheckedValue="true"
                    v-bind:isReadOnly="searching"
                    v-bind:UncheckedValue="false"
                    v-model="parameters.bypassFollowScheduler"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col class="col-12">
                <MdButton
                    v-bind:Label="$t('Shared.Search')"
                    v-bind:Name="'btnSearchAttendance'"
                    v-bind:ClassProp="'secondary mx-2 btn-login pull-right'"
                    v-on:click="searchAsync"
                    :isReadOnly="searching"
                />
            </b-col>
        </b-row>

        <MdTitle
            v-bind:Text="$t('Shared.SearchResult')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col class="col-md-12">
                <MdTable
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:FieldsDate="fieldsDateArr"
                    v-bind:VisibleEditIcon="hasPermissionEdit()"
                    :editIconEvent="edit"
                    :onRowSelected="onRowSelected"
                    :onFiltered="onFiltered"
                    :pageChanged="pageChanged"
                    :perPageFunction="perPageFunction"
                >
                </MdTable>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Permission from '@/common/Permission';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import ClinicalService from '@/services/clinical.service';
import PatientService from '@/services/patient.service';
import EmployeeService from '@/services/employee.service';
import ClaimBatch from '@/services/claimbatch.service';
import Utils from '@/common/utils';
import moment from 'moment';
import UserPreference from '@/services/quickhelp.service';
import LocalStorage from '@/services/storage.service';

export default {
    name: 'DateRangeAttendanceList',
    mixins: [ShowMessage, DBFunctions, Permission],

    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: '',
                Mode: this.edit_mode,
                favButtonAtion: false
            },
            isReadOnly: false,
            showMessageIsEmpty: false,
            fields: [
                {
                    key: 'patientCode',
                    sortable: true,
                    label: this.$t('Shared.PatientCode'),
                    class: 'text-left'
                },
                {
                    key: 'patientName',
                    sortable: true,
                    label: this.$t('Shared.PatientName'),
                    class: 'text-left'
                },
                {
                    key: 'programName',
                    sortable: true,
                    label: this.$tc('Shared.Program', 2),
                    class: 'text-left'
                },
                {
                    key: 'dateFrom',
                    sortable: true,
                    label: this.$t('Shared.datefrom'),
                    class: 'text-center',
                    formatter: value => {
                        return Utils.formatterDateToString(value);
                    }
                },
                {
                    key: 'dateTo',
                    sortable: true,
                    label: this.$t('Shared.dateTo'),
                    class: 'text-center',
                    formatter: value => {
                        return Utils.formatterDateToString(value);
                    }
                }
            ],
            fieldsDateArr: ['dateFrom', 'dateTo'],
            items: [],
            programList: [],
            patientList: [],
            therapistList: [],
            programVModel: [],
            therapiesList: [],
            billingList: [],
            patientVModel: null,
            therapistModel: null,
            therapiesModel: null,
            billingModel: null,
            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            parameterSearch: {},
            selectPlaceholder: this.$t('Clinical.SelectOptions'),
            parameters: {
                programList: [],
                patientList: [],
                therapistCodeList: [],
                therapyCodeList: [],
                billingCodesList: [],
                dateFrom: moment()
                    .subtract(7, 'days')
                    .format('YYYY-MM-DD'),
                dateTo: Utils.formatterDate(Date(), 'LLLL'),
                bypassFollowScheduler: false
            },
            parametersUsed: {},
            searching: false,
            isDateToValid: true,
            isDateFromValid: true
        };
    },

    methods: {
        edit(item) {
            const parameters = {
                ...this.parametersUsed,
                selectProgram: item.programCode?.trim(),
                patientName: item.patientName,
                selectProgramName: item.programName?.trim(),
                currentPage: this.currentPage
            };
            delete parameters.PageNumber;
            delete parameters.PageSize;

            sessionStorage.setItem('DateRangeAttendanceFilters', JSON.stringify(parameters));
            this.$router
                .push({
                    name: 'date-range-attendance-edit',
                    params: { id: item.patientCode.trim() }
                })
                .catch(() => {});
        },

        onRowSelected() {},

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        pageChanged(page) {
            this.currentPage = page;
            this.listingAsync();
        },

        perPageFunction(perPage) {
            this.perPage = perPage;
            this.currentPage = 1;
            this.listingAsync();
        },

        changeDropDownPrograms(items) {
            this.parameters.programList = items ? items.map(element => element.code) : [];
        },

        changeDropDownPatients(items) {
            this.parameters.patientList = items ? items.map(element => element.code) : [];
        },

        changeDropDownTherapist(therapist) {
            this.parameters.therapistCodeList = therapist
                ? therapist.map(element => element.code)
                : [];
        },

        changeDropDownTherapy(therapies) {
            this.parameters.therapyCodeList = therapies
                ? therapies.map(element => element.code)
                : [];
        },

        changeDropDownBilling(items) {
            this.parameters.billingCodesList = items ? items.map(element => element.code) : [];
        },

        dateFromChanged(value) {
            this.parameters.dateFrom = value;
            this.searchAsync();
        },

        dateToChanged(value) {
            this.parameters.dateTo = value;
            this.searchAsync();
        },

        searchAsync() {
            this.currentPage = 1;
            this.listingAsync();
        },

        listingAsync(updatePreference = true) {
            const result = Utils.validateDateRange(
                this.parameters.dateFrom,
                this.parameters.dateTo
            );
            if (!result.valid) {
                this.isDateToValid = !result.fields.includes('toDate');
                this.isDateFromValid = !result.fields.includes('fromDate');
                this.showMessage(this.$tc('Msg.Error'), this.$t(result.message), 'error');
                return;
            }

            this.searching = true;
            this.parameters.PageNumber = this.currentPage;
            this.parameters.PageSize = this.perPage;
            ClaimBatch.getDateRangeAttendanceName(this.parameters)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;

                        let headerString = response.headers['x-pagination'];
                        this.Header = JSON.parse(headerString);
                        this.totalRows = this.Header.TotalCount;

                        if (updatePreference) {
                            this.updateLastDateRangeAttendancePreference();
                        }

                        this.parametersUsed = this.parameters;
                    }

                    this.showMessageIsEmpty = this.items.length === 0;
                    this.searching = false;
                })
                .catch(error => {
                    this.searching = false;
                    this.showResponseErrorMessage(error);
                });
        },

        async getPrograms() {
            const parameter = {
                //programsRestriction:  this.$store.state.restrictions.programs
            };
            await ClinicalService.getProgramLookup(parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.programList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getPatients() {
            await PatientService.getPatientLookup()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.patientList = response.data.map(element => ({
                            code: element.code,
                            description: element.description + ' - ' + element.code
                        }));
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getAllEmployee() {
            await EmployeeService.getEmployeeLookupByType()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.therapistList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getTherapies() {
            await ClinicalService.getTherapiesLookUp()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.therapiesList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getBillingCodes() {
            await ClinicalService.getTherapyBillingLookUp()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.billingList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getUserPreference() {
            await UserPreference.getQhUserPreference(LocalStorage.getUserId())
                .then(response => {
                    if (response.data && response.data.length > 0) {
                        let lastDateRangeAttendance = response.data[0].lastDateRangeAttendance;

                        if (!Utils.isNullOrEmptyString(lastDateRangeAttendance)) {
                            try {
                                const dateRangeAttendance = JSON.parse(lastDateRangeAttendance);

                                if ('programList' in dateRangeAttendance) {
                                    this.parameters.programList = Utils.splitOrEmpty(
                                        dateRangeAttendance.programList,
                                        ','
                                    );
                                    this.programVModel = this.parameters.programList.map(x => ({
                                        code: x
                                    }));
                                }

                                if ('patientList' in dateRangeAttendance) {
                                    this.parameters.patientList = Utils.splitOrEmpty(
                                        dateRangeAttendance.patientList,
                                        ','
                                    );
                                    this.patientVModel = this.parameters.patientList.map(x => ({
                                        code: x
                                    }));
                                }

                                if ('therapistCodeList' in dateRangeAttendance) {
                                    this.parameters.therapistCodeList = Utils.splitOrEmpty(
                                        dateRangeAttendance.therapistCodeList,
                                        ','
                                    );
                                    this.therapistModel = this.parameters.therapistCodeList.map(
                                        x => ({
                                            code: x
                                        })
                                    );
                                }

                                if ('therapyCodeList' in dateRangeAttendance) {
                                    this.parameters.therapyCodeList = Utils.splitOrEmpty(
                                        dateRangeAttendance.therapyCodeList,
                                        ','
                                    );
                                    this.therapiesModel = this.parameters.therapyCodeList.map(
                                        x => ({
                                            code: x
                                        })
                                    );
                                }

                                if ('billingCodesList' in dateRangeAttendance) {
                                    this.parameters.billingCodesList = Utils.splitOrEmpty(
                                        dateRangeAttendance.billingCodesList,
                                        ','
                                    );
                                    this.billingModel = this.parameters.billingCodesList.map(x => ({
                                        code: x
                                    }));
                                }

                                if ('dateFrom' in dateRangeAttendance) {
                                    this.parameters.dateFrom = dateRangeAttendance.dateFrom;
                                }

                                if ('dateTo' in dateRangeAttendance) {
                                    this.parameters.dateTo = dateRangeAttendance.dateTo;
                                }

                                if ('bypassFollowScheduler' in dateRangeAttendance) {
                                    this.parameters.bypassFollowScheduler =
                                        dateRangeAttendance.bypassFollowScheduler;
                                }
                            } catch (error) {
                                this.showResponseErrorMessage(error);
                            }
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async updateLastDateRangeAttendancePreference() {
            const data = this.prepareParametersToJson();

            await UserPreference.updateLastDateRangeAttendance(LocalStorage.getUserId(), {
                lastDateRangeAttendance: JSON.stringify(data)
            }).catch(error => {
                this.showResponseErrorMessage(error);
            });
        },

        prepareParametersToJson() {
            return {
                programList: this.parameters.programList.join(','),
                patientList: this.parameters.patientList.join(','),
                therapistCodeList: this.parameters.therapistCodeList.join(','),
                therapyCodeList: this.parameters.therapyCodeList.join(','),
                billingCodesList: this.parameters.billingCodesList.join(','),
                dateFrom: this.parameters.dateFrom,
                dateTo: this.parameters.dateTo,
                bypassFollowScheduler: this.parameters.bypassFollowScheduler
            };
        },

        async initializeData() {
            await Promise.allSettled([
                this.getPrograms(),
                this.getPatients(),
                this.getAllEmployee(),
                this.getTherapies(),
                this.getBillingCodes(),
                this.getUserPreference()
            ]);
        },

        initializeListing() {
            const stored = sessionStorage.getItem('DateRangeAttendancePage');

            if (stored) {
                this.currentPage = Number(stored);
                sessionStorage.removeItem('DateRangeAttendancePage');
            }

            this.listingAsync(false);
        },

        setupEventListeners() {},

        cleanupEventListeners() {}
    },

    created() {
        this.setupEventListeners();
    },

    async mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;

        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        this.initializeData().then(() => this.$nextTick(() => this.initializeListing()));
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy() {
        this.cleanupEventListeners();
    }
};
</script>
